module.exports = __webpack_public_path__ + "static/media/SarahSwitek_04_BodySensations_14.02f7a3fc.mp3";